import { AncillaryOption } from '@eti/schema-types';
import { getPriceDivided } from '../../common/utils/price';
import { getPriceProps, isObjectEmpty } from '../../common/utils/productCardProps';
export const AirportDirection = {
  From: 0,
  To: 1,
  None: 2,
  Both: 3
};
export const withoutNulls = () => item => item != null;
const getAirportDirectionType = operatorBound => {
  var _operatorBound$, _operatorBound$2;
  if (!operatorBound) {
    return AirportDirection.None;
  }
  if ((operatorBound === null || operatorBound === void 0 ? void 0 : operatorBound.length) > 1) {
    return AirportDirection.Both;
  }
  if ((operatorBound === null || operatorBound === void 0 ? void 0 : operatorBound.length) === 1 && ((_operatorBound$ = operatorBound[0]) === null || _operatorBound$ === void 0 ? void 0 : _operatorBound$.boundIndex) === 1) {
    return AirportDirection.From;
  }
  if ((operatorBound === null || operatorBound === void 0 ? void 0 : operatorBound.length) === 1 && ((_operatorBound$2 = operatorBound[0]) === null || _operatorBound$2 === void 0 ? void 0 : _operatorBound$2.boundIndex) !== 1) {
    return AirportDirection.To;
  }
  return AirportDirection.None;
};
const findFirstUrl = text => {
  const urlRegex = /https?:\/\/[^\s/$.?#][^\s"']*/;
  const match = text.match(urlRegex);
  return match ? match[0] : null;
};
export const getOperatorList = (t, isSelected, product, sellSpecification) => {
  var _sellSpecification$ex;
  return sellSpecification === null || sellSpecification === void 0 || (_sellSpecification$ex = sellSpecification.externalChoices) === null || _sellSpecification$ex === void 0 ? void 0 : _sellSpecification$ex.map(exChoice => {
    var _exChoice$distribusio, _operatorData$0$trans, _operatorData$0$terms, _operatorData$;
    const operatorData = (_exChoice$distribusio = exChoice === null || exChoice === void 0 ? void 0 : exChoice.distribusionChoiceBoundData.filter(withoutNulls())) !== null && _exChoice$distribusio !== void 0 ? _exChoice$distribusio : [];
    if (!exChoice || !operatorData || operatorData.length === 0) {
      return null;
    }
    const totalPrice = exChoice.pricePerTravelers.reduce((a, b) => {
      var _b$price$price$value, _b$price;
      return a + ((_b$price$price$value = b === null || b === void 0 || (_b$price = b.price) === null || _b$price === void 0 || (_b$price = _b$price.price) === null || _b$price === void 0 ? void 0 : _b$price.value) !== null && _b$price$price$value !== void 0 ? _b$price$price$value : 0);
    }, 0);
    const totalDivider = exChoice.pricePerTravelers.filter(travelerPrice => {
      var _travelerPrice$price;
      return (travelerPrice === null || travelerPrice === void 0 || (_travelerPrice$price = travelerPrice.price) === null || _travelerPrice$price === void 0 || (_travelerPrice$price = _travelerPrice$price.price) === null || _travelerPrice$price === void 0 ? void 0 : _travelerPrice$price.value) !== 0;
    }).length;
    const priceRaw = getPriceDivided(totalPrice, totalDivider);
    const {
      price
    } = getPriceProps(t, isSelected, {
      ...product,
      priceRaw
    });
    const airportDirection = getAirportDirectionType(operatorData.map(choiceData => choiceData === null || choiceData === void 0 ? void 0 : choiceData.boundAndSegmentIndices));
    const {
      transferCarrier,
      transferType
    } = operatorData[0];
    const transferTime = airportDirection === AirportDirection.Both ? operatorData.map(choice => {
      var _choice$transferTime;
      return (_choice$transferTime = choice.transferTime) !== null && _choice$transferTime !== void 0 ? _choice$transferTime : 0;
    }).reduce((a, b) => a + b, 0) / 2 : (_operatorData$0$trans = operatorData[0].transferTime) !== null && _operatorData$0$trans !== void 0 ? _operatorData$0$trans : 0;
    const termsAndConditions = findFirstUrl((_operatorData$0$terms = (_operatorData$ = operatorData[0]) === null || _operatorData$ === void 0 ? void 0 : _operatorData$.termsAndConditions) !== null && _operatorData$0$terms !== void 0 ? _operatorData$0$terms : '');
    const transferBoundData = operatorData.map(operator => {
      return {
        arrivalDateTime: operator === null || operator === void 0 ? void 0 : operator.arrivalDateTime,
        departureDateTime: operator === null || operator === void 0 ? void 0 : operator.departureDateTime,
        arrivalStation: operator === null || operator === void 0 ? void 0 : operator.arrivalStation,
        departureStation: operator === null || operator === void 0 ? void 0 : operator.departureStation,
        boundAndSegmentIndices: operator === null || operator === void 0 ? void 0 : operator.boundAndSegmentIndices,
        termsAndConditions
      };
    });
    return {
      ancillaryOption: exChoice.ancillaryOption,
      transferTime,
      externalChoiceId: exChoice.externalChoiceId,
      transferCarrier,
      transferType,
      price,
      priceRaw,
      airportDirection,
      transferBoundData
    };
  }).filter(withoutNulls());
};
export const sortOperatorList = operatorList => {
  const hasCheapest = operatorList.length > 1 && operatorList[0].priceRaw !== operatorList[1].priceRaw;
  return hasCheapest ? operatorList : operatorList.map(operator => ({
    ...operator,
    ancillaryOption: (operator === null || operator === void 0 ? void 0 : operator.ancillaryOption) === AncillaryOption.Cheapest ? undefined : operator.ancillaryOption
  })).sort((a, b) => {
    var _a$transferTime, _b$transferTime;
    return ((_a$transferTime = a.transferTime) !== null && _a$transferTime !== void 0 ? _a$transferTime : 0) - ((_b$transferTime = b.transferTime) !== null && _b$transferTime !== void 0 ? _b$transferTime : 0);
  });
};
const formatTravelTime = (value, unitSingular, unitPlural) => {
  if (value > 0) {
    const unit = value > 1 ? unitPlural : unitSingular;
    return `${value} ${unit}`;
  }
  return '';
};
const hoursInSeconds = 3600;
export const convertToHoursAndMinutes = (totalSeconds, hourSingularText, hourPluralText, minuteSingularText, minutePluralText, transferTimeTranslation) => {
  const hours = Math.floor(totalSeconds / hoursInSeconds);
  const minutes = Math.round((totalSeconds - hours * hoursInSeconds) / 60);
  return `${formatTravelTime(hours, hourSingularText, hourPluralText)} ${formatTravelTime(minutes, minuteSingularText, minutePluralText)} ${transferTimeTranslation}`;
};
export const NoneOption = 'NONE';
export const validateAirportTransferTranslations = tranlation => {
  try {
    if (isObjectEmpty(tranlation)) {
      return false;
    }
    const {
      card,
      drawer,
      cart
    } = tranlation;
    if (isObjectEmpty(card) || isObjectEmpty(drawer) || isObjectEmpty(cart)) {
      return false;
    }
    const {
      cheapest,
      fastest,
      seeDetails,
      reject,
      transferTime,
      transportAvailable,
      fromAirport,
      toAirport,
      transfer,
      bus,
      train,
      hour,
      hours,
      minute,
      minutes,
      perPerson
    } = card;
    const {
      availableTickets,
      ticketDetails,
      available,
      unavailable,
      termsAndConditions,
      transferBetween,
      andTranslation,
      conditions,
      operatingHours,
      pleaseNote,
      operatingHoursContent,
      conditionsContent,
      pleaseNoteContent
    } = drawer;
    return Boolean(cheapest && fastest && seeDetails && reject && transferTime && transportAvailable && fromAirport && toAirport && transfer && bus && train && hour && hours && minute && minutes && perPerson && availableTickets && ticketDetails && available && unavailable && termsAndConditions && transferBetween && andTranslation && operatingHours && conditions && pleaseNote && operatingHoursContent && conditionsContent && pleaseNoteContent && cart.tickets);
  } catch (error) {
    return false;
  }
};
//# sourceMappingURL=utils.js.map